import * as React from 'react';
import { Maybe } from '../../../client/types/generated/types';

interface IUseImageLoaded {
  url: Maybe<string> | undefined;
  visible?: boolean;
}
export const useImageLoaded = ({ url, visible = true }: IUseImageLoaded) => {
  if (typeof window !== 'undefined') {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
      if (visible) {
        const img = document.createElement('img');
        const onLoad = () => {
          setLoaded(true);
        };
        const onError = () => {
          setLoaded(true);
          setError(true);
        };
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
        if (url) {
          img.src = url;
        }
        return () => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('load', onError);
        };
      }
    }, [url, visible]);

    React.useEffect(() => {
      if (!url) {
        setLoaded(true);
        setError(true);
      }
    }, [url]);
    return { loaded, error };
  }
  return { loaded: false, error: false };
};
